import { getCurrentUserAccessLevel } from "./getCurrentUseAccessLevel";
import { jwtDecode } from "jwt-decode";

export function userHasAccess(subModuleName, minAccessLevel) {
  const token = localStorage.getItem("accessToken");
  const role = jwtDecode(token).role;
  const type = jwtDecode(token).user_type;
  if (role !== 'user' || type === 'administrator') {
    return true;
  }
  else {
    const userAccessLevel = getCurrentUserAccessLevel(subModuleName);
    if (userAccessLevel < minAccessLevel) {
      return false;
    } else {
      return true;
    }
  }
}